// REQ-F-102: 企業従業員管理機能
// 要件定義通りの単独機能として実装

import React from 'react';
import {
  Box,
  Card,
  CardContent,
  Typography,
  CircularProgress,
  Alert,
} from '@mui/material';
import { useAuth } from '../../hooks/useAuth';
import { useCompanyId } from '../../hooks/useCompanyId';
import { EmployeeManagementPageMUI } from '../../components/Employee/EmployeeManagementPageMUI';
import { CompanyLayout } from '../../components/Layout';

interface CompanyManagementPageProps {}

export const CompanyManagementPage: React.FC<
  CompanyManagementPageProps
> = () => {
  const { user } = useAuth();
  const { companyId, loading, error, isCompanyUser } = useCompanyId();

  // 権限チェック
  if (!user || !isCompanyUser) {
    return (
      <CompanyLayout>
        <Box
          sx={{
            minHeight: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: '#F9FAFB',
          }}
        >
          <Card sx={{ maxWidth: 400, textAlign: 'center' }}>
            <CardContent sx={{ p: 4 }}>
              <Typography
                variant="h4"
                component="h2"
                sx={{ mb: 2, color: '#111827' }}
              >
                アクセス権限がありません
              </Typography>
              <Typography variant="body1" sx={{ color: '#6B7280' }}>
                従業員管理機能は企業ユーザーのみ利用できます。
              </Typography>
            </CardContent>
          </Card>
        </Box>
      </CompanyLayout>
    );
  }

  // ローディング中
  if (loading) {
    return (
      <CompanyLayout>
        <Box
          sx={{
            minHeight: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <CircularProgress size={40} />
        </Box>
      </CompanyLayout>
    );
  }

  // エラー表示
  if (error || !companyId) {
    return (
      <CompanyLayout>
        <Box
          sx={{
            minHeight: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            p: 3,
          }}
        >
          <Alert severity="error" sx={{ maxWidth: 400 }}>
            <Typography variant="h6" gutterBottom>
              企業情報の取得に失敗しました
            </Typography>
            <Typography variant="body2">
              {error ||
                '企業情報が見つかりません。管理者にお問い合わせください。'}
            </Typography>
          </Alert>
        </Box>
      </CompanyLayout>
    );
  }

  return (
    <CompanyLayout>
      <EmployeeManagementPageMUI companyId={companyId} />
    </CompanyLayout>
  );
};
